<div class="ui form search-params">
  <div *ngIf="showSortBy" class="field">
    <label data-lokalise data-key="txt_sort_by_field_label"></label>
    <gd-product-templates-list-sorting-order-selector
      [sortingParams]="sortingParams$ | async"
      (sortingParamsChange)="onSortingParamsChange($event)"
    >
    </gd-product-templates-list-sorting-order-selector>
  </div>

  <div class="field">
    <gd-product-template-name-search-field
      [templateName]="templateName$ | async"
      (templateNameChange)="onTemplateNameChange($event)"
    ></gd-product-template-name-search-field>
  </div>
</div>
